import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';

@Injectable({ providedIn: 'root' })
export class SentryService {
	public setUserScope(scope) {
		const zku = localStorage.getItem('zku');
		if (zku) {
			const entry = JSON.parse(zku);
			if (entry!.data!.id) {
				scope.setUser({
					id: entry!.data!.id,
					email: entry!.data!.email,
					username: entry!.data!.name,
					timezone: entry!.data!.timezone,
					mainType: entry!.data!.mainType,
				});
			}
		}
	}

	public captureException(error: any) {
		Sentry.withScope((scope) => {
			this.setUserScope(scope);
			Sentry.captureException(
				error.originalError || error.rejection || error,
				scope
			);
		});
	}

	public setBreadcrumb(breadcrumb: string, category, data?: any) {
		Sentry.addBreadcrumb({
			category: category,
			message: breadcrumb,
			data: data,
			level: 'info',
			type: 'default',
		});
	}
}
